var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5559_217781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20543 9.10575L13.8394 9.10575C13.8483 9.10575 13.8594 9.10575 13.8684 9.10352C13.9666 9.08789 14.0313 8.99637 14.0157 8.89816L13.9999 3.36245C13.9865 3.27539 13.9106 3.21289 13.8235 3.21289L6.20543 3.21289C6.11837 3.21289 6.04248 3.27539 6.02909 3.36244L6.02909 8.89816C6.02685 8.90709 6.02685 8.91825 6.02685 8.92718C6.02685 9.02539 6.10721 9.10575 6.20543 9.10575ZM7.77686 4.73075L12.2635 4.73075L12.2635 7.58789L7.77686 7.58789L7.77686 4.73075Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3404 16.782L18.9744 16.782C18.9833 16.782 18.9945 16.782 19.0034 16.7798C19.1016 16.7642 19.1663 16.6726 19.1507 16.5744L19.1349 11.0387C19.1215 10.9517 19.0456 10.8892 18.9585 10.8892L11.3404 10.8892C11.2534 10.8892 11.1775 10.9517 11.1641 11.0387L11.1641 16.5744C11.1619 16.5834 11.1619 16.5945 11.1619 16.6034C11.1619 16.7017 11.2422 16.782 11.3404 16.782ZM12.9119 12.407L17.3985 12.407L17.3985 15.2642L12.9119 15.2642L12.9119 12.407Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02549 16.782L8.65943 16.782C8.66835 16.782 8.67951 16.782 8.68844 16.7798C8.78666 16.7642 8.85139 16.6726 8.83577 16.5744L8.81993 11.0387C8.80653 10.9517 8.73064 10.8892 8.64359 10.8892L1.0255 10.8892C0.938441 10.8892 0.862548 10.9517 0.849155 11.0387L0.849155 16.5744C0.846923 16.5834 0.846923 16.5945 0.846923 16.6034C0.846923 16.7017 0.92728 16.782 1.02549 16.782ZM2.59692 12.407L7.08353 12.407L7.08353 15.2642L2.59692 15.2642L2.59692 12.407Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5559_217781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.bd849f501e00421679947c5a432094e9.svg";
export { ForwardRef as ReactComponent };